/**
 *
 * AssignmentDispatched
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.oceanGreenDark};
    background: ${COLORS.oceanGreenLight};
    border-color: ${COLORS.oceanGreen};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.oceanGreen};
    }
  }
`;

function AssignmentDispatched(props) {
  return (
    <StyledTag
      label="Assignment Dispatched"
      icon={<PinTripIcon />}
      {...props}
    />
  );
}

export default memo(AssignmentDispatched);
